<template>
  <SectionBox>
    <BasicSection>
      <div v-if="showAdminLinks" class="vacancy-header__admin-links">
        <BasicLink
          v-if="employerData.edit"
          title="Редактировать"
          :href="employerData.edit"
        />
        <BasicLink
          v-if="employerData.analytics"
          title="Статистика"
          :href="employerData.analytics"
        />
      </div>

      <div class="vacancy-header__title">
        <PageTitle :title="vacancy.title" />
        <div class="vacancy-header__date">
          <BasicText color="muted">
            <BasicDate
              v-if="vacancy.publishedDate"
              v-bind="vacancy.publishedDate"
            />
            <template v-else>Вакансия никогда не публиковалась</template>
          </BasicText>
        </div>
      </div>

      <ContentSection
        v-if="vacancy.salary && vacancy.salary.formatted"
        title="Зарплата"
      >
        <BasicSalary appearance="vacancy-header" :salary="vacancy.salary" />
      </ContentSection>

      <ContentSection
        v-if="vacancy.skills && vacancy.skills.length"
        title="Требования"
      >
        <VacancySkills :vacancy="vacancy" />
      </ContentSection>

      <ContentSection title="Местоположение и тип занятости">
        <VacancyMeta :vacancy="vacancy" />
      </ContentSection>

      <ContentSection v-if="mediaQueries.mobile" title="Компания">
        <VacancyCompany :company="company" :show-inactive="showAdminLinks" />
      </ContentSection>
    </BasicSection>
  </SectionBox>
</template>

<script>
import BasicDate from 'src/components/BasicDate/BasicDate.vue';
import BasicLink from 'src/components/BasicLink/BasicLink.vue';
import BasicSalary from 'src/components/BasicSalary/BasicSalary.vue';
import PageTitle from 'src/components/PageTitle/PageTitle.vue';
import SectionBox from 'src/components/SectionBox/SectionBox.vue';
import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';
import BasicText from 'src/components/text/BasicText/BasicText.vue';
import VacancyCompany from 'src/components/vacancies/VacancyCompany/VacancyCompany.vue';
import VacancyMeta from 'src/components/vacancies/VacancyMeta/VacancyMeta.vue';
import VacancySkills from 'src/components/vacancies/VacancySkills/VacancySkills.vue';

export default {
  name: 'VacancyHeader',
  components: {
    BasicSalary,
    BasicDate,
    BasicText,
    BasicSection,
    BasicLink,
    ContentSection,
    PageTitle,
    VacancyCompany,
    SectionBox,
    VacancySkills,
    VacancyMeta,
  },

  inject: ['mediaQueries'],

  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    employerData: {
      type: Object,
      default: () => {},
    },
    company: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showAdminLinks() {
      if (!this.employerData) return false;
      return !!(this.employerData.edit || this.employerData.analytics);
    },
  },
};
</script>
